"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var FileListItem = __importStar(require("./M_DanaFileListItem"));
var Status = __importStar(require("./A_DanaStatus"));
var Button = __importStar(require("./A_Button"));
var Component = function (p) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
    return (Preact.h(Box_1.default, { sx: { border: '1px solid', borderColor: 'primary', marginY: '8px' } },
        Preact.h(Box_1.default, { sx: { display: 'flex', justifyContent: 'space-between', paddingY: '8px' } },
            Preact.h(Box_1.default, { sx: { display: 'flex', flexDirection: 'column' } },
                Preact.h(Typography_1.default, null,
                    "Kind: ",
                    p.model.kind,
                    " "),
                Preact.h(Typography_1.default, null,
                    "Type: ",
                    p.model.articleType,
                    " "),
                Preact.h(Typography_1.default, null,
                    "Created ",
                    p.model.created,
                    " "),
                Preact.h(Typography_1.default, null,
                    "Last Modified: ",
                    p.model.lastModified,
                    " "),
                Preact.h(Typography_1.default, null,
                    "Notes: ",
                    p.model.notes,
                    " ")),
            Preact.h(Status.Component, { status: p.model.status }),
            Preact.h(Box_1.default, null,
                Preact.h(Button.Component, { variant: "outlined", onClick: function () { return p.onPass(p.model); } }, "Pass"),
                Preact.h(Button.Component, { variant: "outlined", onClick: function () { return p.onFail(p.model); } }, "Fail"))),
        Preact.h(Typography_1.default, null, "Files:"),
        Preact.h(FileListItem.Component, { kind: "model", format: "glb", location: (_b = (_a = p.model.files.model) === null || _a === void 0 ? void 0 : _a.glb) === null || _b === void 0 ? void 0 : _b.location, created: (_d = (_c = p.model.files.model) === null || _c === void 0 ? void 0 : _c.glb) === null || _d === void 0 ? void 0 : _d.created, lastModified: (_f = (_e = p.model.files.model) === null || _e === void 0 ? void 0 : _e.glb) === null || _f === void 0 ? void 0 : _f.lastModified, onUpdate: p.onFileUpdate, onUpload: p.onFileUpload, onDownload: p.onFileDownload }),
        Preact.h(FileListItem.Component, { kind: "model", format: "max", location: (_h = (_g = p.model.files.model) === null || _g === void 0 ? void 0 : _g.max) === null || _h === void 0 ? void 0 : _h.location, created: (_k = (_j = p.model.files.model) === null || _j === void 0 ? void 0 : _j.max) === null || _k === void 0 ? void 0 : _k.created, lastModified: (_m = (_l = p.model.files.model) === null || _l === void 0 ? void 0 : _l.max) === null || _m === void 0 ? void 0 : _m.lastModified, onUpdate: p.onFileUpdate, onUpload: p.onFileUpload, onDownload: p.onFileDownload }),
        Preact.h(FileListItem.Component, { kind: "model", format: "blend", location: (_p = (_o = p.model.files.model) === null || _o === void 0 ? void 0 : _o.blend) === null || _p === void 0 ? void 0 : _p.location, created: (_r = (_q = p.model.files.model) === null || _q === void 0 ? void 0 : _q.blend) === null || _r === void 0 ? void 0 : _r.created, lastModified: (_t = (_s = p.model.files.model) === null || _s === void 0 ? void 0 : _s.blend) === null || _t === void 0 ? void 0 : _t.lastModified, onUpdate: p.onFileUpdate, onUpload: p.onFileUpload, onDownload: p.onFileDownload }),
        Preact.h(FileListItem.Component, { kind: "attachments", format: "json", location: (_v = (_u = p.model.files.attachments) === null || _u === void 0 ? void 0 : _u.json) === null || _v === void 0 ? void 0 : _v.location, created: (_x = (_w = p.model.files.attachments) === null || _w === void 0 ? void 0 : _w.json) === null || _x === void 0 ? void 0 : _x.created, lastModified: (_z = (_y = p.model.files.attachments) === null || _y === void 0 ? void 0 : _y.json) === null || _z === void 0 ? void 0 : _z.lastModified, onUpdate: p.onFileUpdate, onUpload: p.onFileUpload, onDownload: p.onFileDownload })));
};
exports.Component = Component;
